import React from "react";

function InputGroup(props) {
  return (
    <div className="w-full">
      <label htmlFor={props.label} className="font-medium block mb-2">
        {props.label}
      </label>
      <input
        type="text"
        id={props.label}
        placeholder={props.placeholder}
        className="w-full bg-white rounded-lg p-2 focus:outline-none"
      />
    </div>
  );
}

export default InputGroup;
